export enum FlexWorkerLevelFilters {
  ALL = 'ALL',
  INCOMPLETE = 'INCOMPLETE',
  STARTER = 'STARTER',
  EXPLORER = 'EXPLORER',
  CANDIDATE = 'CANDIDATE',
  WORKER = 'WORKER',
  COMPLETE = 'COMPLETE',
}

export type GetWorkerExistsByEmailParams = {
  email: string;
  verified?: boolean;
  level?: FlexWorkerLevelFilters;
};
